import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "template-form-wrap" }

import {
  reactive, ref,
} from 'vue';
import type { FormInstance } from 'element-plus';

import { TemplateFormTypes, TemplateTypes } from '@/types/TemplateTypes';
import { getTemplate, updateTemplate } from '@/api/templateRequests';
import {
  Bold,
  BulletList,
  Document, Blockquote,
  Italic,
  Link,
  OrderedList,
  Paragraph,
  Text,
  Underline, History,
} from 'element-tiptap';
import { isMobile } from '@/helpers/breakpoints';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateForm',
  setup(__props) {


const ruleFormRef = ref<FormInstance>();

const ruleForm = reactive<TemplateTypes>({
  title: '',
  description: '',
});

const formState = reactive<TemplateFormTypes>({
  isError: false,
  isSuccess: false,
  isLoading: false,
});

const onCreate = async ({ editor }: any) => {
  const data = await getTemplate();
  formState.isLoading = true;
  if (data) {
    Object.assign(ruleForm, data);
    formState.isLoading = false;
  }
  editor.commands.setContent(data.description);
};

const extensions = [
  Document.configure({}),
  Text,
  Paragraph,
  Link.configure({ bubble: true }),
  Bold.configure({ bubble: true }),
  Underline,
  History,
  Italic,
  Blockquote,
  BulletList,
  OrderedList,
];

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid) => {
    if (valid) {
      formState.isError = false;
      formState.isLoading = true;
      formState.isSuccess = false;
      updateTemplate(ruleForm).catch(() => {
        formState.isError = true;
        formState.isLoading = false;
      }).finally(() => {
        formState.isLoading = false;
        formState.isSuccess = true;
      });
    }
  });
};


return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_element_tiptap = _resolveComponent("element-tiptap")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (formState.isError)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          title: "There is an error",
          type: "error"
        }))
      : _createCommentVNode("", true),
    (formState.isSuccess)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 1,
          title: "The template was updated",
          type: "success"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      model: ruleForm,
      "label-width": "100px",
      size: "large",
      "label-position": _unref(isMobile) ? 'top' : 'left',
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      class: "sending-form",
      disabled: formState.isLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "Title",
          prop: "title",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.title) = $event)),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Description",
          prop: "description",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_element_tiptap, {
              content: ruleForm.description,
              "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.description) = $event)),
              extensions: extensions,
              enableCharCount: false,
              onOnCreate: onCreate
            }, null, 8, ["content"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(ruleFormRef.value))),
              loading: formState.isLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "label-position", "disabled"])
  ]))
}
}

})